import { apiURLV1 } from '../../config';

export const NotificationsApiRoutes = {
  base: `${apiURLV1}/notifications`,
};

export const MESSAGES = {};
